export default function userStatusColor(status: string, expanded?: boolean): string {
    switch (status) {
        case 'available':
            return '#596be3'

        case 'inbound':
            return '#00C8F4'

        case 'follow_up':
            return '#18bab2'

        case 'meeting':
            return '#ff7e7e'

        case 'break':
            return '#ff8c51'

        case 'pause':
            return '#91B1DC'

        default:
            const color = expanded ? '#596be3' : 'red'
            return color
    }
}
